/**
 * Wholesale Add All Varieties Feature
 * Adds "Add 1 of each" buttons to product groups in wholesale pages
 */

// ============================================
// FIX: Create missing v1 variables for v2 product/quickbuy page compatibility
// The Easy Wholesale app v2 on product/quickbuy pages is missing variables that exist on v1:
// - nm_wh_collection (empty object)
// - nm_easywholesale_show (true)
// This polyfill adds them to prevent the app from crashing.
// ============================================
(function fixWholesaleV2Compatibility() {
    const isProductPage = window.location.pathname.includes('/products/');
    const isQuickOrderPage = window.location.pathname.includes('quick-order');
    const needsPolyfill = isProductPage || isQuickOrderPage;

    if (needsPolyfill) {
        // Set missing v1 variables immediately
        if (typeof window.nm_wh_collection === 'undefined') {
            window.nm_wh_collection = {};
        }
        if (typeof window.nm_easywholesale_show === 'undefined') {
            window.nm_easywholesale_show = true;
        }

        // Also set on DOMContentLoaded in case they get overwritten
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                if (typeof window.nm_wh_collection === 'undefined') {
                    window.nm_wh_collection = {};
                }
                if (typeof window.nm_easywholesale_show === 'undefined') {
                    window.nm_easywholesale_show = true;
                }
            });
        }
    }
})();
// ============================================
// END FIX
// ============================================


class WholesaleAddAll {
    constructor() {
        this.init();
    }

    init() {
        // Wait for DOM and wholesale components to load
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.setupButtons();
                this.injectMassyPriceContainers();
                this.setupStickyFooter();      // Product pages: make sticky visible
                this.setupAllStickyPrices();   // ALL pages: update sticky prices with Massy discounts
            });
        } else {
            this.setupButtons();
            this.injectMassyPriceContainers();
            this.setupStickyFooter();          // Product pages: make sticky visible
            this.setupAllStickyPrices();       // ALL pages: update sticky prices with Massy discounts
        }

        // Also setup when wholesale content dynamically loads
        this.observeWholesaleChanges();
    }

    /**
     * Setup Massy price updates for sticky footer on ALL pages
     * This is page-type agnostic - if a sticky exists, update its prices
     */
    setupAllStickyPrices() {
        const sticky = document.querySelector('.nm-wholesale-main-fix');
        if (sticky) {
            this.setupStickyPriceUpdates(sticky);
        }
    }

    setupButtons() {
        // Check if we're on a product page first - if so, only create one button
        const isProductPage = window.location.pathname.includes('/products/');

        if (isProductPage && document.querySelector('.wholesale-add-all-btn')) {
            return; // Button already exists on product page
        }

        // Define selectors to try
        const selectors = [
            '.nm-easywholesale-product',
            '.nm-wholesale-product',
            '.wholesale-product',
            '[class*="wholesale"][class*="product"]'
        ];

        let productGroups = [];

        // Try each selector until we find elements
        for (const selector of selectors) {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                productGroups = elements;
                break;
            }
        }

        // If no direct matches, look for broader wholesale containers
        if (productGroups.length === 0) {
            const containers = document.querySelectorAll('[class*="wholesale"]');
            if (containers.length > 0) {
                productGroups = containers;
            }
        }

        // For product pages, just process the first group and exit
        if (isProductPage && productGroups.length > 0) {
            this.addButtonToGroup(productGroups[0]);
            return;
        }

        // For wholesale pages, process all groups
        productGroups.forEach((group) => {
            // Skip if button already exists
            if (group.querySelector('.wholesale-add-all-btn')) {
                return;
            }

            this.addButtonToGroup(group);
        });
    }

    addButtonToGroup(group) {
        // Skip if button already exists anywhere in this group
        if (group.querySelector('.wholesale-add-all-btn')) return;

        // Check if we're on a product page vs wholesale page
        const isProductPage = window.location.pathname.includes('/products/') &&
            !group.classList.contains('nm-easywholesale-container') &&
            !group.classList.contains('nm-wholesale-container');

        if (isProductPage) {
            this.addButtonToProductPage(group);
        } else {
            this.addButtonToWholesalePage(group);
        }
    }

    addButtonToProductPage(group) {
        // Check if button already exists on the entire page (not just this group)
        if (document.querySelector('.wholesale-add-all-btn')) {
            return;
        }

        // Look for wholesale table header first (preferred location)
        const wholesaleHeader = document.querySelector('.nm-easywholesale-header');
        if (wholesaleHeader) {
            this.addButtonToWholesaleHeader(wholesaleHeader);
            return;
        }

        // Fallback to original ADD TO CART container logic
        const addToCartContainer = document.querySelector('.product-form__cart') ||
            document.querySelector('[class*="add-to-cart"]') ||
            document.querySelector('#AddToCart')?.parentElement ||
            document.querySelector('button[name="add"]')?.parentElement ||
            document.querySelector('.nm-wholesale-table')?.querySelector('.nm-wholesale-bottom');

        if (!addToCartContainer) {
            console.log('No add to cart container found on product page');
            return;
        }

        const button = this.createButton();

        // Style the container to hold both buttons - responsive gap
        const isMobile = window.innerWidth <= 749;
        addToCartContainer.style.display = 'flex';
        addToCartContainer.style.gap = isMobile ? '3px' : '10px';
        addToCartContainer.style.alignItems = 'stretch';
        addToCartContainer.style.flexWrap = 'nowrap';
        addToCartContainer.style.justifyContent = isMobile ? 'flex-start' : 'space-between';
        addToCartContainer.style.width = '100%';

        // Apply mobile-specific styling if needed
        if (isMobile) {
            setTimeout(() => {
                // Apply styles directly to enforce side-by-side layout
                addToCartContainer.style.cssText += `
                    display: flex !important;
                    flex-direction: row !important;
                    flex-wrap: nowrap !important;
                    gap: 3px !important;
                    align-items: stretch !important;
                    justify-content: flex-start !important;
                    width: 100% !important;
                `;

                // Style the wholesale button
                button.style.cssText += `
                    flex: 1 1 60% !important;
                    max-width: 60% !important;
                    margin: 0 !important;
                    font-size: 1.4rem !important;
                    padding: 0.4rem 0.3rem !important;
                    white-space: normal !important;
                    overflow: visible !important;
                    text-overflow: clip !important;
                    line-height: 1.2 !important;
                    transform: none !important;
                    text-align: center !important;
                    max-height: none !important;
                `;

                // Style the ADD TO CART button
                const addToCartBtn = addToCartContainer.querySelector('button[name="add"], #AddToCart');
                if (addToCartBtn) {
                    addToCartBtn.style.cssText += `
                        flex: 1 1 35% !important;
                        max-width: 35% !important;
                        font-size: 0.9rem !important;
                        padding: 0.5rem 0.3rem !important;
                    `;
                }
            }, 100);
        }

        // Add our button to the right side (end of container)
        addToCartContainer.appendChild(button);

        this.attachButtonEvents(button, document.body);
    }

    addButtonToWholesaleHeader(headerContainer) {
        const button = this.createButton();

        // Create a container for the button in the header
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'wholesale-header-button-container';
        buttonContainer.style.cssText = `
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px 0;
            margin-top: 5px;
            width: 100%;
            box-sizing: border-box;
        `;

        // Style the button for header placement
        button.style.cssText += `
            min-width: 200px;
            max-width: 280px;
            width: 50%;
            padding: 0.8rem 1.2rem;
            font-size: 1.3rem;
            font-weight: 700;
            border-radius: 6px;
        `;

        buttonContainer.appendChild(button);
        headerContainer.appendChild(buttonContainer);

        this.attachButtonEvents(button, document.body);
    }

    addButtonToWholesalePage(group) {
        const button = this.createButton();
        const isMobile = window.innerWidth <= 749;

        if (isMobile) {
            // On mobile: add button under the title area
            const titleContainer = group.querySelector('.nm-wholesale-title-foto') ||
                group.querySelector('.nm-wholesale-header') ||
                group.querySelector('[class*="wholesale-header"]') ||
                group.querySelector('[class*="title"]');

            if (!titleContainer) {
                console.log('No title container found for mobile wholesale button');
                return;
            }

            // Create a container for the mobile button under title
            const mobileButtonContainer = document.createElement('div');
            mobileButtonContainer.className = 'wholesale-mobile-title-button-container';
            mobileButtonContainer.style.cssText = `
                width: 100% !important;
                padding: 8px 15px !important;
                display: flex !important;
                justify-content: center !important;
                margin: 5px 0 2px 0 !important;
                background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
                border-radius: 8px;
                border: 1px solid rgba(255, 255, 255, 0.1);
            `;

            button.style.cssText += `
                width: 100% !important;
                max-width: 300px !important;
                font-size: 1.2rem !important;
                padding: 0.75rem 1rem !important;
            `;

            mobileButtonContainer.appendChild(button);

            // Insert AFTER the title container, not inside it
            titleContainer.parentNode.insertBefore(mobileButtonContainer, titleContainer.nextSibling);
        } else {
            // On desktop: keep inline with title
            let titleElement = group.querySelector('.nm-easywholesale-linktitle') ||
                group.querySelector('.nm-wholesale-header-title a') ||
                group.querySelector('.nm-wholesale-header-title') ||
                group.querySelector('.nm-wholesale-header') ||
                group.querySelector('h3 a') ||
                group.querySelector('h2 a') ||
                group.querySelector('h1 a') ||
                group.querySelector('[class*="title"]') ||
                group.querySelector('[class*="header"]');

            if (!titleElement) {
                console.log('No title element found in wholesale group', group);
                return;
            }

            let titleContainer = titleElement.closest('.nm-wholesale-header') ||
                titleElement.closest('.nm-easywholesale-header') ||
                titleElement.closest('[class*="header"]') ||
                titleElement.parentElement;

            if (!titleContainer) {
                console.log('No title container found');
                return;
            }

            // Make the title container a flex container and add button
            titleContainer.style.display = 'flex';
            titleContainer.style.justifyContent = 'space-between';
            titleContainer.style.alignItems = 'center';
            titleContainer.style.flexWrap = 'wrap';
            titleContainer.appendChild(button);
        }

        this.attachButtonEvents(button, group);
    }

    createButton() {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wholesale-add-all-btn';
        button.title = 'Add the full line to cart';
        button.innerHTML = `
            <span class="btn-text">Add the full line to cart</span>
            <span class="btn-icon">⚡</span>
        `;
        return button;
    }

    attachButtonEvents(button, group) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            this.addOneOfEach(group, button);
        });
    }

    async addOneOfEach(group, button) {
        // Show processing state immediately
        button.classList.add('processing');
        const originalText = button.querySelector('.btn-text').textContent;
        button.querySelector('.btn-text').textContent = 'Adding to cart...';

        // Find all item rows in this group
        const rawItems = Array.from(group.querySelectorAll('.nm-wholesale-table tr, [class*="wholesale"] tr, [class*="wholesale"] .row, [class*="wholesale-item"]'));

        // Filter for visible items only (to avoid mobile/desktop duplication)
        const items = rawItems.filter(item => {
            const rect = item.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0;
        });

        let addedCount = 0;
        const itemsToAdd = [];
        const seenVariantIds = new Set();
        let outOfStockVarieties = [];

        console.log(`Checking ${items.length} visible items in group`);

        // First pass: extract all unique visible variant IDs and check stock
        for (const item of items) {
            // Check if item is sold out/disabled
            const isSoldOut = item.classList.contains('disabled') ||
                item.classList.contains('sold-out') ||
                item.querySelector('.sold-out, .disabled');

            // Extract variant ID
            let variantId = item.dataset.variantId ||
                item.dataset.id ||
                item.getAttribute('data-variant-id') ||
                item.getAttribute('data-id');

            if (!variantId) {
                const inputWithId = item.querySelector('[data-variant-id], [data-id], input[name*="id"]');
                if (inputWithId) {
                    variantId = inputWithId.dataset.variantId || inputWithId.dataset.id || inputWithId.name.match(/\[(\d+)\]/)?.[1];
                }
            }

            if (!variantId) {
                const plusBtn = item.querySelector('.nm-easywholesale-qty-increase, [class*="increase"]');
                if (plusBtn) {
                    variantId = plusBtn.dataset.id || plusBtn.dataset.variantId || plusBtn.id.match(/(\d+)$/)?.[1];
                }
            }

            if (variantId) {
                const cleanId = variantId.toString().replace(/^nm-/, '').replace(/\D/g, '');
                if (cleanId && !isNaN(cleanId) && !seenVariantIds.has(cleanId)) {
                    seenVariantIds.add(cleanId);

                    if (isSoldOut) {
                        const varietyName = item.querySelector('.nm-easywholesale-name, [class*="name"]')?.textContent?.trim() || `ID: ${cleanId}`;
                        outOfStockVarieties.push(varietyName);
                    } else {
                        itemsToAdd.push({
                            id: parseInt(cleanId),
                            quantity: 1
                        });
                        addedCount++;
                    }
                }
            }
        }

        // If any of the VISIBLE variants are out of stock, abort everything
        if (outOfStockVarieties.length > 0) {
            console.log('Aborting: Out of stock varieties found:', outOfStockVarieties);
            this.showToast('Some items out of stock.', 'warning');
            this.resetButton(button, originalText);
            return;
        }

        if (itemsToAdd.length > 0) {
            try {
                // Add items directly to Shopify cart
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: itemsToAdd
                    })
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log('Items successfully added to cart');

                    // Trigger cart drawer update
                    if (window.theme && window.theme.cart) {
                        window.theme.cart.updateCartDrawer();
                    }

                    // Refresh the page immediately to update wholesale UI
                    window.location.reload();
                } else {
                    const errorData = await response.json();
                    console.error('Shopify API Error:', errorData);
                    const errorMessage = errorData.description || errorData.message || 'Failed to add items to cart';
                    this.showToast(errorMessage, 'error');
                    this.resetButton(button, originalText);
                }
            } catch (error) {
                console.error('Fetch Error:', error);
                this.showToast('Error connecting to cart', 'error');
                this.resetButton(button, originalText);
                return;
            }
        } else {
            // Update UI
            if (addedCount === 0) {
                this.showToast('No available varieties found', 'warning');
                this.resetButton(button, originalText);
            }
        }

        // Trigger global recalculation
        this.triggerWholesaleUpdate();
    }

    resetButton(button, originalText) {
        if (button) {
            button.classList.remove('processing');
            if (originalText && button.querySelector('.btn-text')) {
                button.querySelector('.btn-text').textContent = originalText;
            }
        }
    }

    triggerWholesaleUpdate() {
        // Try to trigger any wholesale app recalculation methods
        setTimeout(() => {
            // Common wholesale app update triggers
            window.dispatchEvent(new Event('wholesale:update'));
            document.dispatchEvent(new Event('cart:update'));

            // Trigger any existing wholesale update functions
            if (window.updateWholesaleTotal) window.updateWholesaleTotal();
            if (window.refreshWholesaleCart) window.refreshWholesaleCart();
            if (window.nm_wholesale_update) window.nm_wholesale_update();
        }, 100);
    }

    showToast(message, type = 'success') {
        console.log(`Showing toast: [${type}] ${message}`);
        // Create simple toast notification
        const toast = document.createElement('div');
        toast.className = `wholesale-toast wholesale-toast-${type}`;
        toast.textContent = message;

        document.body.appendChild(toast);

        // Animate in
        setTimeout(() => toast.classList.add('show'), 50);

        // Remove after delay
        setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => {
                if (toast.parentNode) document.body.removeChild(toast);
            }, 500);
        }, 4000);
    }

    /**
     * Inject Massy discounted prices into Easy Wholesale price elements
     * Uses Massy.getPrice() API to fetch real discounted prices dynamically
     */
    async injectMassyPriceContainers() {
        // Inject discounts into variant rows on product and quick-order pages

        // Check if Massy is available
        if (!window.Massy || !window.Massy.getPrice) {
            console.log('[WholesaleAddAll] Massy.getPrice not available, skipping price injection');
            return;
        }

        // Check if user has a tier (only show discounts for logged-in tier customers)
        if (!window.customerTier) {
            console.log('[WholesaleAddAll] No customer tier detected, skipping Massy prices');
            return;
        }

        // Find all Easy Wholesale price elements
        const priceElements = document.querySelectorAll('.nm-easywholesale-price');
        let processedCount = 0;

        for (const priceElement of priceElements) {
            // Skip if already processed
            if (priceElement.dataset.massyInjected === 'true') {
                continue;
            }

            // Get product info
            const parentItem = priceElement.closest('.nm-easywholesale-item');
            if (!parentItem) {
                continue;
            }

            // Get variant ID - try multiple sources
            let variantId = parentItem.dataset.variantId ||
                parentItem.querySelector('[data-variant-id]')?.dataset.variantId ||
                parentItem.querySelector('[data-id]')?.dataset.id ||
                parentItem.querySelector('.nm-easywholesale-qty-increase')?.id?.replace('nm-', '');

            if (!variantId) {
                continue;
            }

            // Clean the variant ID (remove any prefixes)
            variantId = variantId.toString().replace(/^nm-/, '');

            // Get the current/original price text
            const currentPriceText = priceElement.textContent.trim();
            const priceMatch = currentPriceText.match(/\$([\d,]+\.?\d*)/);
            if (!priceMatch) {
                continue;
            }

            const originalPriceValue = parseFloat(priceMatch[1].replace(',', ''));
            const originalPriceFormatted = '$' + originalPriceValue.toFixed(2);

            try {
                // Call Massy API to get discounted price
                const discountedPrice = await window.Massy.getPrice(variantId);

                // Skip if no discount or same as original
                if (!discountedPrice || discountedPrice <= 0 || discountedPrice >= originalPriceValue) {
                    // Mark as processed even if no discount
                    priceElement.dataset.massyInjected = 'true';
                    continue;
                }

                const discountedPriceFormatted = '$' + discountedPrice.toFixed(2);

                // Create the Massy wrapper structure
                const wrapper = document.createElement('span');
                wrapper.className = 'massy-custom-pricing-price-wrapper';

                // Original price (crossed out)
                const originalSpan = document.createElement('span');
                originalSpan.className = 'massy-custom-pricing-price-original';
                originalSpan.textContent = originalPriceFormatted;

                // Discounted price with tier class for badge coloring
                const discountSpan = document.createElement('span');
                discountSpan.className = 'massy-custom-pricing-price-discount';
                if (window.customerTier) {
                    discountSpan.classList.add(window.customerTier + '-tier');
                }
                discountSpan.textContent = discountedPriceFormatted;

                wrapper.appendChild(originalSpan);
                wrapper.appendChild(discountSpan);

                // Replace the price element content
                priceElement.innerHTML = '';
                priceElement.appendChild(wrapper);

                // Store the discounted price for tooltip use
                priceElement.dataset.massyDiscountedPrice = discountedPrice;
                priceElement.dataset.massyOriginalPrice = originalPriceValue;

                processedCount++;
            } catch (error) {
                console.warn('[WholesaleAddAll] Error getting Massy price for variant', variantId, error);
            }

            // Mark as processed
            priceElement.dataset.massyInjected = 'true';
        }

        console.log(`[WholesaleAddAll] Injected Massy discounts into ${processedCount}/${priceElements.length} price elements`);

        // After injecting prices, setup the total observer
        this.observeAndUpdateTotal();
    }

    /**
     * Create sticky footer bar for product pages - uses exact same structure as Easy Wholesale app
     */
    setupStickyFooter() {
        const isProductPage = window.location.pathname.includes('/products/');
        if (!isProductPage) return;

        // Find the existing sticky created by Easy Wholesale app (it's hidden on product pages)
        const existingSticky = document.querySelector('.nm-wholesale-main-fix');

        if (existingSticky) {
            // App creates this but hides it on product pages - force it visible
            // IMPORTANT: Only set visibility properties, NOT positioning
            // The app's CSS already has proper responsive positioning via media queries
            // Setting inline positioning would override those media queries
            console.log('[WholesaleAddAll] Found hidden app sticky, making it visible');

            existingSticky.style.setProperty('display', 'block', 'important');
            existingSticky.style.setProperty('visibility', 'visible', 'important');
            existingSticky.style.setProperty('opacity', '1', 'important');

            // Also show any hidden child elements
            const innerFix = existingSticky.querySelector('.nm-wholesale-fix');
            if (innerFix) {
                innerFix.style.setProperty('display', 'block', 'important');
                innerFix.style.setProperty('visibility', 'visible', 'important');
            }

            // Hide the inline footer since we're using the sticky
            const inlineFooter = document.querySelector('.nm-easywholesale-footer:not(.nm-wholesale-main-fix .nm-easywholesale-footer)');
            if (inlineFooter) inlineFooter.style.display = 'none';

            // Hide add to cart button - try multiple selectors for mobile compatibility
            const addToCartSelectors = [
                '.nm-easywholesale-add-to-cart-container:not(.nm-wholesale-main-fix .nm-easywholesale-add-to-cart-container)',
                '.nm-wholesale-btn-add-to-cart:not(.nm-wholesale-main-fix .nm-wholesale-btn-add-to-cart)',
                'button.nm-wholesale-btn-add-to-cart',
                '.nm-easywholesale-footer button:not(.nm-wholesale-main-fix button)',
                '.nm-wholesale-table button[name="add"]:not(.nm-wholesale-main-fix button)'
            ];

            addToCartSelectors.forEach(selector => {
                const element = document.querySelector(selector);
                if (element) {
                    console.log(`[WholesaleAddAll] Hiding add to cart with selector: ${selector}`);
                    element.style.display = 'none';
                }
            });

            // Price updates are now handled by setupAllStickyPrices() which runs on ALL pages
            return;
        }

        // Fallback: If no app sticky exists, wait for wholesale content
        const existingFooter = document.querySelector('.nm-easywholesale-footer');
        if (!existingFooter) return;

        console.log('[WholesaleAddAll] No app sticky found, creating our own');

        // Hide inline footer
        existingFooter.style.display = 'none';

        // Hide add to cart button - try multiple selectors for mobile compatibility
        const addToCartSelectors = [
            '.nm-easywholesale-add-to-cart-container',
            '.nm-wholesale-btn-add-to-cart',
            'button.nm-wholesale-btn-add-to-cart',
            '.nm-easywholesale-footer button',
            '.nm-wholesale-table button[name="add"]'
        ];

        addToCartSelectors.forEach(selector => {
            const element = document.querySelector(selector);
            if (element) {
                console.log(`[WholesaleAddAll] Fallback: Hiding add to cart with selector: ${selector}`);
                element.style.display = 'none';
            }
        });

        // Create sticky with app's structure
        const stickyFooter = document.createElement('div');
        stickyFooter.className = 'nm-wholesale-main-fix';
        stickyFooter.innerHTML = `
            <div class="nm-wholesale-fix">
                <div class="nm-wholesale-fix-inner">
                    <div class="nm-easywholesale-footer">
                        <div class="nm-easywholesale-selected nm-primary-color">Total selected items: <span class="nm-total-selected-items-fix">0</span></div>
                        <div class="nm-easywholesale-total-fix nm-primary-color">$0.00</div>
                    </div>
                    <div class="nm-easywholesale-add-to-cart-container-page-fix">
                        <button type="button" class="nm-wholesale-btn-add-to-cart nm-secondary-background-color">ADD TO CART</button>
                    </div>
                </div>
            </div>
        `;
        document.body.appendChild(stickyFooter);
        // Price updates handled by setupAllStickyPrices() which runs after this
    }

    /**
     * Setup Massy price updates for sticky footer
     */
    setupStickyPriceUpdates(stickyFooter) {
        const stickyTotal = stickyFooter.querySelector('.nm-easywholesale-total-fix');
        if (!stickyTotal) return;

        let isUpdating = false; // Guard against infinite loops

        const updateStickyTotal = () => {
            if (isUpdating) return;

            let totalPrice = 0;

            document.querySelectorAll('.nm-easywholesale-item').forEach(item => {
                const qtyInput = item.querySelector('.nm-easywholesale-qty');
                const qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;
                if (qty <= 0) return;

                const priceEl = item.querySelector('.nm-easywholesale-price');
                if (priceEl?.dataset.massyDiscountedPrice) {
                    totalPrice += qty * parseFloat(priceEl.dataset.massyDiscountedPrice);
                }
            });

            if (totalPrice > 0) {
                const formatted = '$' + totalPrice.toFixed(2);
                if (stickyTotal.textContent.trim() !== formatted) {
                    isUpdating = true;
                    stickyTotal.textContent = formatted;
                    setTimeout(() => { isUpdating = false; }, 100);
                }
            }
        };

        // Observe the sticky total for app updates and override with Massy prices
        new MutationObserver(() => {
            if (!isUpdating) requestAnimationFrame(updateStickyTotal);
        }).observe(stickyTotal, {
            childList: true, characterData: true, subtree: true
        });

        // Also update on quantity changes
        document.querySelectorAll('.nm-easywholesale-qty').forEach(input => {
            input.addEventListener('change', () => setTimeout(updateStickyTotal, 50));
            input.addEventListener('input', () => setTimeout(updateStickyTotal, 50));
        });

        updateStickyTotal();
    }

    /**
     * Observe and update the wholesale total (#nm-total-summ-selected) with Massy discounted prices
     */
    observeAndUpdateTotal() {
        const totalElement = document.querySelector('#nm-total-summ-selected');
        if (!totalElement) return;

        let isUpdating = false;

        const updateTotal = () => {
            if (isUpdating) return;

            let discountedTotal = 0;
            let hasDiscounts = false;

            document.querySelectorAll('.nm-easywholesale-item').forEach(item => {
                const qtyInput = item.querySelector('.nm-easywholesale-qty');
                const qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;
                if (qty <= 0) return;

                const priceEl = item.querySelector('.nm-easywholesale-price');
                if (priceEl?.dataset.massyDiscountedPrice) {
                    discountedTotal += qty * parseFloat(priceEl.dataset.massyDiscountedPrice);
                    hasDiscounts = true;
                }
            });

            if (hasDiscounts && discountedTotal > 0) {
                const formatted = '$' + discountedTotal.toFixed(2);
                if (totalElement.textContent.trim() !== formatted) {
                    isUpdating = true;
                    totalElement.textContent = formatted;
                    console.log('[WholesaleAddAll] Updated total to Massy discounted price:', formatted);
                    setTimeout(() => { isUpdating = false; }, 100);
                }
            }
        };

        // Run immediately and observe total element for wholesale app overwrites
        updateTotal();

        new MutationObserver(() => requestAnimationFrame(updateTotal)).observe(totalElement, {
            childList: true, characterData: true, subtree: true
        });
    }

    observeWholesaleChanges() {
        // Watch for dynamically loaded wholesale content
        const observer = new MutationObserver((mutations) => {
            let shouldSetup = false;

            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && (
                        node.classList?.contains('nm-easywholesale-product') ||
                        node.querySelector?.('.nm-easywholesale-product')
                    )) {
                        shouldSetup = true;
                    }
                });
            });

            if (shouldSetup) {
                setTimeout(() => {
                    this.setupButtons();
                    this.injectMassyPriceContainers();
                    this.setupStickyFooter();
                    this.setupAllStickyPrices();
                }, 100);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}

// Singleton instance to prevent duplicate button handlers
let wholesaleAddAllInstance = null;

function initWholesaleAddAll() {
    if (!document.querySelector('.nm-easywholesale-container, .nm-wholesale-container')) {
        return;
    }

    if (wholesaleAddAllInstance) {
        // Instance exists - retry Massy price injection and sticky prices
        console.log('[WholesaleAddAll] Already initialized, retrying Massy price injection and sticky prices');
        wholesaleAddAllInstance.injectMassyPriceContainers();
        wholesaleAddAllInstance.setupStickyFooter();
        wholesaleAddAllInstance.setupAllStickyPrices();
        return;
    }

    console.log('[WholesaleAddAll] Initializing singleton instance');
    wholesaleAddAllInstance = new WholesaleAddAll();
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initWholesaleAddAll);

// Retry later to catch Massy API and wholesale content that loads after DOM
setTimeout(initWholesaleAddAll, 1000);
setTimeout(initWholesaleAddAll, 2000);

// Dedicated sticky footer check for product pages - keeps checking until wholesale content loads
if (window.location.pathname.includes('/products/')) {
    let stickyCheckCount = 0;
    const stickyCheckInterval = setInterval(() => {
        stickyCheckCount++;
        const footer = document.querySelector('.nm-easywholesale-footer');
        const stickyExists = document.querySelector('.nm-wholesale-main-fix');

        if (footer && !stickyExists && wholesaleAddAllInstance) {
            console.log('[WholesaleAddAll] Sticky check found footer, creating sticky');
            wholesaleAddAllInstance.setupStickyFooter();
        }

        // Stop checking after 10 seconds or if sticky is created
        if (stickyCheckCount > 20 || stickyExists) {
            clearInterval(stickyCheckInterval);
        }
    }, 500);
}

